import Component from './Impersonate.vue';

export default Component;
